// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__el8JJ","list":"styles_list__1ZK8R"};